/**
 * Animaciones de entrada (hero y otros)
 * Añade la clase que dispara las animaciones CSS cuando el DOM está listo.
 * Respeta prefers-reduced-motion.
 */

function addEntranceDone(el, className) {
  if (!el) return;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    el.classList.add(className);
    return;
  }
  requestAnimationFrame(() => {
    el.classList.add(className);
  });
}

function initHeroEntrance() {
  const hero = document.querySelector('.hero-section');
  if (!hero) return;
  const run = () => addEntranceDone(hero, 'hero-entrance-done');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
}

function initSingleEntrance() {
  const headerWrap = document.querySelector('.single-entry__header-wrap');
  const single = document.querySelector('.single-entry');
  const run = () => {
    if (headerWrap) addEntranceDone(headerWrap, 'single-entrance-done');
    if (single) addEntranceDone(single, 'single-entrance-done');
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
}

function initExperienciaEntrance() {
  const section = document.querySelector('.experiencia-section');
  if (!section) return;
  const run = () => addEntranceDone(section, 'experiencia-entrance-done');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
}

function initAuthorEntrance() {
  const setup = () => {
    const section = document.querySelector('.author-archive');
    if (!section) return;

    const run = () => addEntranceDone(section, 'author-entrance-done');
    run();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}

function initCategoryEntrance() {
  const setup = () => {
    const section = document.querySelector('.category-archive');
    if (!section) return;

    const run = () => addEntranceDone(section, 'category-entrance-done');
    run();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}

function initTagEntrance() {
  const setup = () => {
    const section = document.querySelector('.tag-archive');
    if (!section) return;

    const run = () => addEntranceDone(section, 'tag-entrance-done');
    run();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}

function initSectionsShortcodeEntrance() {
  const run = () => {
    document.querySelectorAll('.edas-sections-shortcode').forEach((section) => {
      addEntranceDone(section, 'sections-shortcode-entrance-done');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
}

function initContactMapEntrance() {
  const setup = () => {
    const column = document.querySelector('.edas-contact-map-column');
    if (!column) return;

    const run = () => addEntranceDone(column, 'contact-map-entrance-done');
    run();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}

/**
 * Page template: animación de entrada por bloque al cargar.
 * - Página por defecto: h1 y cada hijo directo de .page-template__content bajo .column.
 * - Page columns: h1, subtítulo opcional y hijos de .page-template__content (sin .column).
 * - Contacto: todos los .edas-contact-item dentro de .page-template.edas-contact-page.
 * Las clases de entrada se añaden al cargar, sin depender de scroll.
 */
function initPageTemplateEntrance() {
  const setup = () => {
    const pageColumns = document.querySelector('.page-template.page-columns-template');
    const contactPage = document.querySelector('.page-template.edas-contact-page');

    const blocks = [];
    if (pageColumns) {
      const postCategory = pageColumns.querySelector('.page-columns-template__post-category');
      const h1 = pageColumns.querySelector('.page-columns-template__header > h1');
      const postTags = pageColumns.querySelector('.page-columns-template__post-tags');
      const subtitle = pageColumns.querySelector('.page-columns-template__subtitle');
      const toolbar = pageColumns.querySelector('.page-columns-template__toolbar');
      const content = pageColumns.querySelector('.page-template__content');
      if (postCategory) blocks.push(postCategory);
      if (h1) blocks.push(h1);
      if (subtitle) blocks.push(subtitle);
      if (toolbar) blocks.push(toolbar);
      if (content) blocks.push(...Array.from(content.children));
      if (postTags) blocks.push(postTags);
    } else if (contactPage) {
      contactPage.querySelectorAll('.edas-contact-item').forEach((el) => blocks.push(el));
    } else {
      const column = document.querySelector('.page-template .column');
      if (column) {
        const h1 = column.querySelector(':scope > h1');
        const content = column.querySelector('.page-template__content');
        if (h1) blocks.push(h1);
        if (content) blocks.push(...Array.from(content.children));
      }
    }

    if (blocks.length === 0) return;

    blocks.forEach((el) => addEntranceDone(el, 'page-block-entrance-done'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}

initHeroEntrance();
initSingleEntrance();
initExperienciaEntrance();
initAuthorEntrance();
initCategoryEntrance();
initTagEntrance();
initSectionsShortcodeEntrance();
initContactMapEntrance();
initPageTemplateEntrance();
